<div>
    <div class="connect-common-page-header" *ngIf="isSelectedSectionPersonalDetails()">
        <div class="padding-top-10 padding-bottom-5">
            <h2 class="display-block header-text semi-bold-font">Personal Details</h2>
            <div *ngIf="isUploadDriverLicenseEmpty()" class="header-details">
                <i class="fa fa-info-circle padding-right-5"></i>
                <span >Uploading your Driver’s Licence can save you time and minimize the risk of human error, by automatically populating your personal details and identification particulars into the Client Intake Request Form. </span>
            </div>
            <div *ngIf="showAllFields" class="header-details">
                <i class="fa fa-info-circle padding-right-5"></i>
                <span >Please enter the personal details for this client. If you are missing any of the required information for this client, please select the “I do not have all details for this client” checkbox. </span>
            </div>
            <div *ngIf="showAllFields">
                <mat-checkbox
                    [(ngModel)]="_cirfClientInfo.allowMissingFields"
                    (change)="changeAllowMissingFields($event.checked)">
                    I do not have all details for this client
                </mat-checkbox >
            </div>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div *ngIf="isSelectedSectionPersonalDetails() && !showAllFields && loadingDocumentsComplete">
        <mat-label class="padding-right-5" >Do you have a Canadian Driver's Licence to upload for {{clientName? clientName : 'the new client being added'}}?</mat-label>
        <mat-form-field class="dl-selection-field">
            <mat-label></mat-label>
            <select matNativeControl my-auto-focus
                    [(ngModel)]="_cirfClientInfo.agreedToUploadDL" (change)="showOrHideAllFields()" aria-label="Canadian Driver's Licence Selection">
                <option *ngFor="let option of uploadDriverLicenseOptions" [value]="option.value" >{{ option.name }}</option>
            </select>
        </mat-form-field>

        <ng-container *ngIf="isUploadDriverLicenseYes()">
            <div class="padding-top-10">
                <h3>Please Upload the Front and Back of the Driver's Licence</h3>
            </div>
            <div class="row">
                <div class="col-10 col-lg-6">
                    <div id="uploadingTipsDiv" class="uploading-tips-div d-block d-lg-none">
                        <div class="margin-bottom-10">
                            <mat-card class="grey-card">
                                <mat-card-subtitle>Uploading Tips</mat-card-subtitle>
                                <mat-card-content>
                                    <ul>
                                        <li>Accepted images format is JPG, PNG, GIF or BMP.</li>
                                        <li>Ensure the driver's licence fills the entire picture, or as close as possible.</li>
                                        <li>Take a horizontal image (landscape format where width is bigger than height) instead of vertical.</li>
                                        <li>Use a tripod or a very steady hand and do not skew the barcode in the photo.</li>
                                        <li>Ensure there are no reflections on the barcode.</li>
                                    </ul>
                                </mat-card-content>
                            </mat-card>
                        </div>

                    </div>
                    <ng-container *ngIf="!driverLicenseFront">
                        <h4>Front of the Driver's Licence</h4>
                        <div class="padding-top-10">
                            <dp-file-upload
                                    [elementId]="'uploadFront'"
                                    [sourceId]="clientId"
                                    [documentType]="'CLIENT'"
                                    [clientName]="clientName"
                                    uploadBtnLabel="Browse"
                                    [documentDescription]="driverLicenseFrontDescription"
                                    [acceptedExtensions]="'*.bmp,*.gif,*.jpeg,*.jpg,*.png'"
                                    (documentUploaded)="driverLicenseUploaded($event)"
                            ></dp-file-upload>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!driverLicenseBack">
                        <h4>Back of the Driver's Licence</h4>
                        <div class="padding-top-10">
                            <dp-file-upload
                                    [elementId]="'uploadBack'"
                                    [sourceId]="clientId"
                                    [documentType]="'CLIENT'"
                                    [clientName]="clientName"
                                    uploadBtnLabel="Browse"
                                    [documentDescription]="driverLicenseBackDescription"
                                    [parseBeforeUpload]="true"
                                    [acceptedExtensions]="'*.bmp,*.gif,*.jpeg,*.jpg,*.png'"
                                    (documentUploaded)="driverLicenseUploaded($event)"
                            ></dp-file-upload>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="driverLicenseFront">
                        <div class="padding-top-10">
                            <mat-list role="list">
                                <mat-list-item role="listitem" (mouseenter)="hoveredIndex=0">
                                    <div class="mat-card-connect-client-list-left">
                                        <mat-icon class="mat-card-connect-icon"
                                                  title="{{driverLicenseFront.description}}"
                                                  *ngIf="driverLicenseFront.isVirusClean()">attachment
                                        </mat-icon>
                                        <mat-icon class="mat-card-connect-icon" title="File is Infected"
                                                  *ngIf="driverLicenseFront.isVirusInfected()">block
                                        </mat-icon>
                                        <mat-icon class="mat-card-connect-icon" title="Virus Scan Pending"
                                                  *ngIf="driverLicenseFront.isVirusPending()">warning
                                        </mat-icon>
                                        <mat-icon class="mat-card-connect-icon" title="Virus Scan In Progress"
                                                  *ngIf="driverLicenseFront.isVirusInProgress()">warning
                                        </mat-icon>
                                        <span class="mat-card-list-text">{{driverLicenseFront.documentName}} - {{driverLicenseFront.description}}</span>

                                    </div>
                                    <div class="mat-card-connect-client-list-right" *ngIf="hoveredIndex==0">
                                        <button class="mat-card-icon" mat-icon-button
                                                aria-label="Delete the front of driver licence file"
                                                (click)="deleteDocument(driverLicenseFront)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                    <mat-divider></mat-divider>
                                </mat-list-item>
                            </mat-list>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="driverLicenseBack">
                        <div class="padding-top-10">
                            <mat-list role="list">
                                <mat-list-item role="listitem" (mouseenter)="hoveredIndex=0">
                                    <div class="mat-card-connect-client-list-left">
                                        <mat-icon class="mat-card-connect-icon"
                                                  title="{{driverLicenseBack.description}}"
                                                  *ngIf="driverLicenseBack.isVirusClean()">attachment
                                        </mat-icon>
                                        <mat-icon class="mat-card-connect-icon" title="File is Infected"
                                                  *ngIf="driverLicenseBack.isVirusInfected()">block
                                        </mat-icon>
                                        <mat-icon class="mat-card-connect-icon" title="Virus Scan Pending"
                                                  *ngIf="driverLicenseBack.isVirusPending()">warning
                                        </mat-icon>
                                        <mat-icon class="mat-card-connect-icon" title="Virus Scan In Progress"
                                                  *ngIf="driverLicenseBack.isVirusInProgress()">warning
                                        </mat-icon>
                                        <span class="mat-card-list-text">{{driverLicenseBack.documentName}} - {{driverLicenseBack.description}}</span>

                                    </div>
                                    <div class="mat-card-connect-client-list-right" *ngIf="hoveredIndex==0">
                                        <button class="mat-card-icon" mat-icon-button
                                                aria-label="Delete the back of driver licence file"
                                                (click)="deleteDocument(driverLicenseBack)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                    <mat-divider></mat-divider>
                                </mat-list-item>
                            </mat-list>
                        </div>
                    </ng-container>

                </div>
                <div class="col-1 col-lg-6">
                    <div class="d-block d-lg-none">
                        <img src="assets/img/question.png" class="cursor-pointer" (click)="toggleUploadingTips()"/>
                    </div>
                    <div class="d-none d-lg-block">
                        <mat-card class="grey-card">
                            <mat-card-subtitle>Uploading Tips</mat-card-subtitle>
                            <mat-card-content>
                                <ul>
                                    <li>Accepted images format is JPG, PNG, GIF or BMP.</li>
                                    <li>Ensure the driver's licence fills the entire picture, or as close as possible.</li>
                                    <li>Take a horizontal image (landscape format where width is bigger than height) instead of vertical.</li>
                                    <li>Use a tripod or a very steady hand and do not skew the barcode in the photo.</li>
                                    <li>Ensure there are no reflections on the barcode.</li>
                                </ul>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </div>




        </ng-container>

    </div>
    <div *ngIf="showAllFields && formGroup" class="padding-10" >

        <form [formGroup]="formGroup">

                <div *ngIf="isSelectedSectionPersonalDetails()">

                    <div class="row">
                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.firstName'">
                            <mat-form-field >
                                <mat-label>First Name</mat-label>
                                <input matInput formControlName="firstName" my-auto-focus maxlength="50">
                                <mat-error>This field is required</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.middleName'">
                            <mat-form-field  >
                                <mat-label>Middle Name(s)</mat-label>
                                <input matInput formControlName="middleName" maxlength="50">
                                <mat-error>This field is required</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.lastName'">
                            <mat-form-field [hideRequiredMarker]="allowMissingFields" >
                                <mat-label>Last Name</mat-label>
                                <input matInput formControlName="lastName" maxlength="100">
                                <mat-error>This field is required</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row col-12 padding-left-0 padding-right-0" [dp-field-visibility]="'cirfClientInfo.gender'">
                            <div class="col-12 col-lg-4 padding-left-0">
                                <mat-form-field  >
                                    <mat-label>Gender</mat-label>
                                    <!-- The native <select> offers the best accessibility as it is supported directly by screen-readers  -->
                                    <select matNativeControl formControlName="gender" #genderSelect aria-label="Select gender">
                                        <option *ngFor="let option of genderOptions" [value]="option.value" >{{ option.name }}</option>
                                    </select>
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row col-12 padding-left-0 padding-right-0" [dp-field-visibility]="'cirfClientInfo.birthDate'">
                            <div class="col-12 col-lg-4 padding-left-0">
                                <mat-form-field  [hideRequiredMarker]="allowMissingFields" >
                                    <mat-label>Birth Date</mat-label>
                                    <input [max]="today" matInput formControlName="birthDate"
                                           [matDatepicker]="birthDatePicker"
                                           (dateChange)="validateDate($event, 'birthDate')"
                                           placeholder="Birth Date (DD/MM/YYYY)" >
                                    <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #birthDatePicker></mat-datepicker>
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                    </div>


                </div>
                <div *ngIf="isSelectedSectionContactDetails()">
                    <div class="row">
                        <h2 class="display-block header-text semi-bold-font">Contact Details</h2>
                        <div class="row col-12 padding-left-0 padding-right-0 padding-bottom-5">
                            <span class="header-details">
                               <i class="fa fa-info-circle padding-right-5"></i>Please enter the contact information for this client.
                            </span>
                        </div>
                        <div class="row col-12 padding-left-0 padding-right-0" [dp-field-visibility]="'cirfClientInfo.email'">
                            <div class="col-12 col-lg-4 padding-left-0">
                                <mat-form-field [hideRequiredMarker]="allowMissingFields" >
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email"  my-auto-focus [pattern]="emailPattern" maxlength="100">
                                    <mat-error *ngIf="formGroup.controls?.email?.errors?.required">Email is required</mat-error>
                                    <mat-error *ngIf="formGroup.controls?.email?.errors?.pattern">Email must be a valid email address
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row col-12 padding-left-0 padding-right-0" *ngIf="cirf?.isMatterPurchase()" >
                            <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.firstTimeHomeBuyer'" >
                                <mat-form-field >
                                    <mat-label>Are you a first time home owner?</mat-label>
                                    <select matNativeControl formControlName="firstTimeHomeBuyer" aria-label="Are you a first time home owner?">
                                        <option *ngFor="let option of firstTimeHomeBuyerOptions" [value]="option.value">
                                            {{option.name }}
                                        </option>
                                    </select>
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row col-12 padding-left-0 padding-right-0" [dp-field-visibility]="'cirfClientInfo.isCanadianResident'">
                            <div class="col-12 col-lg-4 padding-left-0">
                                <mat-form-field [hideRequiredMarker]="allowMissingFields">
                                    <mat-label>Canadian Resident</mat-label>
                                    <!-- The native <select> offers the best accessibility as it is supported directly by screen-readers  -->
                                    <select matNativeControl formControlName="isCanadianResident"
                                            (change)="isCanadianResidentChanged($event)" aria-label="Select Canadian Resident">
                                        <option *ngFor="let option of yesNoOptionsMandatory" [value]="option.value" >{{ option.name }}</option>
                                    </select>
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-lg-4 padding-left-0" *ngIf="isCanadianResident()" [dp-field-visibility]="'cirfClientInfo.residentStatus'">
                                <mat-form-field  [hideRequiredMarker]="allowMissingFields" >
                                    <mat-label>Resident Status</mat-label>
                                    <!-- The native <select> offers the best accessibility as it is supported directly by screen-readers  -->
                                    <select matNativeControl formControlName="residentStatus" aria-label="Select Resident Status">
                                        <option *ngFor="let option of residentStatusOptions" [value]="option.value" >{{ option.name }}</option>
                                    </select>
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 padding-left-0">
                                <div *ngIf="isPermanentResident() && clientName">
                                    <ng-container *ngIf="permanentResidentCard">
                                        <div class="padding-top-10 padding-bottom-10">
                                            <mat-list role="list">
                                                <mat-list-item role="listitem" (mouseenter)="hoveredIndex=0">
                                                    <div class="mat-card-connect-client-list-left">
                                                        <mat-icon class="mat-card-connect-icon"
                                                                  title="{{permanentResidentCard.description}}"
                                                                  *ngIf="permanentResidentCard.isVirusClean()">attachment
                                                        </mat-icon>
                                                        <mat-icon class="mat-card-connect-icon" title="File is Infected"
                                                                  *ngIf="permanentResidentCard.isVirusInfected()">block
                                                        </mat-icon>
                                                        <mat-icon class="mat-card-connect-icon" title="Virus Scan Pending"
                                                                  *ngIf="permanentResidentCard.isVirusPending()">warning
                                                        </mat-icon>
                                                        <mat-icon class="mat-card-connect-icon" title="Virus Scan In Progress"
                                                                  *ngIf="permanentResidentCard.isVirusInProgress()">warning
                                                        </mat-icon>
                                                        <span class="mat-card-list-text">{{permanentResidentCard.documentName}} - {{permanentResidentCard.description}}</span>

                                                    </div>
                                                    <div class="mat-card-connect-client-list-right" *ngIf="hoveredIndex==0">
                                                        <button class="mat-card-icon" mat-icon-button
                                                                aria-label="Delete Permanent Resident Card"
                                                                (click)="deleteDocument(permanentResidentCard)">
                                                            <mat-icon>delete</mat-icon>
                                                        </button>
                                                    </div>
                                                    <mat-divider></mat-divider>
                                                </mat-list-item>
                                            </mat-list>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="!permanentResidentCard">
                                        <div class="padding-top-10">
                                            <dp-file-upload
                                                    [sourceId]="clientId"
                                                    [documentType]="'CLIENT'"
                                                    [clientName]="clientName"
                                                    [uploadBtnLabel]="'Upload Permanent Resident Card'"
                                                    [documentDescription]="permanentResidentCardDescription"
                                                    (documentUploaded)="documentUploaded($event)"
                                            ></dp-file-upload>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                        </div>
                        <div class="row col-12 padding-left-0 padding-right-0" *ngIf="cirf && !cirf.isParticipantCirf() && !cirf.isCustomMatter()">
                            <div class="col-12 col-lg-3 padding-left-0" *ngIf="isSpousalStatusVisible()" [dp-field-visibility]="'cirfClientInfo.spousalStatus'">
                                <mat-form-field  [hideRequiredMarker]="allowMissingFields" >
                                    <mat-label>What is your spousal status?</mat-label>
                                    <!-- The native <select> offers the best accessibility as it is supported directly by screen-readers  -->
                                    <select matNativeControl formControlName="spousalStatus" aria-label="Select your spousal status"
                                            (change)="isSpousalStatusChanged($event)"    >
                                        <option *ngFor="let option of spousalStatusOptions" [value]="option.value" >{{ option.name }}</option>
                                    </select>
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-lg-3 padding-left-0" *ngIf="isSpousalStatusMarried()" [dp-field-visibility]="'cirfClientInfo.isFamilyResidence'">
                                <mat-form-field  [hideRequiredMarker]="allowMissingFields" >
                                    <mat-label>Is this the family residence?</mat-label>
                                    <!-- The native <select> offers the best accessibility as it is supported directly by screen-readers  -->
                                    <select matNativeControl formControlName="isFamilyResidence"  aria-label="Is this the family residence?"  >
                                        <option *ngFor="let option of yesNoOptionsMandatory" [value]="option.value" >{{ option.name }}</option>
                                    </select>
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-lg-3 padding-left-0" *ngIf="isSpousalStatusMarried()" [dp-field-visibility]="'cirfClientInfo.isSpouseOnTitle'">
                                <mat-form-field  [hideRequiredMarker]="allowMissingFields" >
                                    <mat-label>Is spouse on title?</mat-label>
                                    <!-- The native <select> offers the best accessibility as it is supported directly by screen-readers  -->
                                    <select matNativeControl formControlName="isSpouseOnTitle" aria-label="Is spouse on title?"
                                            (change)="isSpouseOnTitleChanged($event)"  >
                                        <option *ngFor="let option of yesNoOptionsMandatory" [value]="option.value">{{
                                            option.name }}
                                        </option>
                                    </select>
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-lg-3 padding-left-0" *ngIf="isSpouseNameVisible()" [dp-field-visibility]="'cirfClientInfo.spouseName'">
                                <mat-form-field  >
                                    <mat-label>Spouse Name</mat-label>
                                    <input matInput formControlName="spouseName" maxlength="100" [readonly]="isSpouseNameReadonly">
                                </mat-form-field>
                            </div>
                            <div class="col-12 padding-left-0">
                                <ng-container *ngIf="isSpouseNameAutoSuggestVisible()">
                                    <dp-connect-auto-suggest
                                            [default]="formGroup.controls?.spouseName"
                                            [placeHolder]="'Spouse Name'" [type]="'SPOUSE'"
                                            (onOptionSelection)="spouseSelected($event)"
                                            [isValidatorRequired]="!allowMissingFields"
                                            [isMatchRequired]="false"
                                            [fullWidth]="false"
                                            [dropDownOptions]="spouseDropDownAutoSuggest"
                                            [readonly]="isSpouseNameReadonly"
                                            [showDeleteButton]="isSpouseNameReadonly && isSpouseOnTitle()"
                                            (deleteAction)="removeSpouse()"
                                            [warningMessage]="'To change details about the spouse (e.g. to correct a misspelled name), once you have finished editing this client, select the other one to apply the necessary changes'"
                                            [showWarningMessage]="isSpouseNameReadonly && isSpouseOnTitle()"
                                            #spouseAutoSuggest
                                    >
                                    </dp-connect-auto-suggest>
                                </ng-container>
                            </div>

                        </div>
                        <div formArrayName="telephones" class="row col-12 padding-left-0 padding-right-0">
                            <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.phone1.telephoneNumber'">
                                <mat-form-field  formGroupName="0" >
                                    <mat-label>Home phone number</mat-label>
                                    <input matInput formControlName="telephoneNumber" dp-phone-number (change)="updatePhoneValidation()">
                                    <mat-error>At least one phone number must be present</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.phone2.telephoneNumber'">
                                <mat-form-field  formGroupName="1"  >
                                    <mat-label>Mobile phone number</mat-label>
                                    <input matInput formControlName="telephoneNumber" dp-phone-number (change)="updatePhoneValidation()">
                                    <mat-error>At least one phone number must be present</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.phone3.telephoneNumber'">
                                <mat-form-field formGroupName="2"  >
                                    <mat-label>Work phone number</mat-label>
                                    <input matInput formControlName="telephoneNumber" dp-phone-number (change)="updatePhoneValidation()">
                                    <mat-error>At least one phone number must be present</mat-error>
                                </mat-form-field>
                            </div>

                        </div>

                        <div class="row col-12 padding-left-0 padding-right-0">
                            <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.occupation'">
                                <mat-form-field >
                                    <mat-label>Occupation</mat-label>
                                    <input maxlength="50" matInput formControlName="occupation">
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <dp-address-form #businessAddress
                                         [formGroup]="formGroup"
                                         formArrayName="addresses"
                                         formArrayIndex="0"
                                         [addressLine1Label]="'Address 1'"
                                         [prefixForVisibilityKey]="'cirfClientInfo.address1'"
                        ></dp-address-form>
                        <dp-cirf-udf
                                [formGroup]="formGroup"
                                [cirfFormArrayName]="'cirfClientInfoUdfs'"
                                [cirfUdfFieldKey]="cirfClientInfoUdfFieldKey"
                                [cirfUdfs]="cirfClientInfoUdfs"
                        ></dp-cirf-udf>
                    </div>
                </div>

                <div class="connect-common-page-header" formArrayName="identifications" *ngIf="anyIdentificationFieldVisible() && (isSelectedSectionIdVerification1() || isSelectedSectionIdVerification2())">
                    <h2 class="header-text semi-bold-font">
                        <div>Identification Verification</div>
                    </h2>
                    <ng-container formGroupName="0" *ngIf="isSelectedSectionIdVerification1()">
                        <div >
                            <span class="header-details">
                                <i class="fa fa-info-circle padding-right-5"></i>Please select an approved piece of ID below and enter the identification information for this client.
                            </span>
                            <div class="padding-top-10" [dp-field-visibility]="'cirfClientInfo.identification1.identificationTypeCode;cirfClientInfo.identification1.identificationNumber;cirfClientInfo.identification1.placeOfIssue;cirfClientInfo.identification1.expiryDate;cirfClientInfo.identification1.country'">
                                <h5>Primary Identification</h5>
                            </div>
                            <div >
                                <div class="row col-12 padding-left-0 padding-right-0">
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.identification1.identificationTypeCode'">
                                        <mat-form-field  [hideRequiredMarker]="allowMissingFields">
                                            <mat-label>Type of ID</mat-label>
                                            <input type="text"
                                                   formControlName='identificationTypeCode'
                                                   maxlength="100"
                                                   my-auto-focus
                                                   matInput
                                                   [matAutocomplete]="auto1">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                        <mat-autocomplete #auto1="matAutocomplete">
                                            <mat-option *ngFor="let option of filteredPrimaryIdentificationOptions" [value]="option.value">
                                                {{option.name}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>

                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.identification1.identificationNumber'">
                                        <mat-form-field  [hideRequiredMarker]="allowMissingFields" >
                                            <mat-label>Number</mat-label>
                                            <input matInput formControlName="identificationNumber" maxlength="50">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row col-12 padding-left-0 padding-right-0">
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.identification1.placeOfIssue'">
                                        <mat-form-field  [hideRequiredMarker]="allowMissingFields" >
                                            <mat-label>Place of Issue</mat-label>
                                            <input matInput formControlName="placeOfIssue" maxlength="50">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.identification1.expiryDate'">
                                        <mat-form-field  >
                                            <mat-label>Expiry Date</mat-label>
                                            <input  matInput formControlName="expiryDate"
                                                    placeholder="Expiry Date (DD/MM/YYYY)"
                                                    (blur)="validateExpiryDate('expiryDate', 'identifications', '0')"
                                            >
                                            <input style="display: none" matInput
                                                   [matDatepicker]="primaryExpiryDatePicker"
                                                   (dateChange)="setExpiryDate('expiryDate', 'identifications', '0' ,$event)"
                                            >
                                            <mat-datepicker-toggle matSuffix [for]="primaryExpiryDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #primaryExpiryDatePicker></mat-datepicker>
                                            <mat-error *ngIf="checkError('expiryDate', 'identifications', '0')">Expiry Date is
                                                invalid</mat-error>
                                            <mat-hint class="warning-box" *ngIf="checkWarning('expiryDate', 'identifications', '0')">Expiry date is incomplete</mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.identification1.country'">
                                        <mat-form-field  >
                                            <mat-label>Country</mat-label>
                                            <input matInput formControlName="country" maxlength="75">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-12 padding-left-0 padding-right-0">
                                    <dp-cirf-udf
                                            [formGroup]="primaryIdentificationFormGroup"
                                            [cirfFormArrayName]="'identificationUdfs'"
                                            [cirfUdfFieldKey]="primaryIdentificationUdfFieldKey"
                                            [cirfUdfs]="primaryIdentificationUdfs"
                                    ></dp-cirf-udf>
                                </div>


                            </div>
                        </div>
                        <div *ngIf="isIdentificationSelected(0) && clientName">
                            <div class="padding-top-10">
                                <h3>{{getUploadText(0)}}</h3>
                            </div>
                            <ng-container *ngIf="isUploadIdVisible(0, frontText)">
                                <div class="padding-top-10">
                                    <dp-file-upload
                                            [sourceId]="clientId"
                                            [documentType]="'CLIENT'"
                                            [clientName]="clientName"
                                            uploadBtnLabel="{{getUploadButtonText(0,frontText)}}"
                                            [documentDescription]="getUploadedFileDescription(0, frontText)"
                                            (documentUploaded)="documentUploaded($event)"
                                    ></dp-file-upload>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="isUploadIdVisible(0, backText)">
                                <div class="padding-top-10">
                                    <dp-file-upload
                                            [sourceId]="clientId"
                                            [documentType]="'CLIENT'"
                                            [clientName]="clientName"
                                            uploadBtnLabel="{{getUploadButtonText(0,backText)}}"
                                            [documentDescription]="getUploadedFileDescription(0, backText)"
                                            (documentUploaded)="documentUploaded($event)"
                                    ></dp-file-upload>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!isUploadIdVisible(0, frontText)">
                                <div class="padding-top-10">
                                    <mat-list role="list" *ngIf="getUploadedDocument(0,frontText)">
                                        <mat-list-item role="listitem" (mouseenter)="hoveredIndex=0">
                                            <div class="mat-card-connect-client-list-left">
                                                <mat-icon class="mat-card-connect-icon"
                                                          title="{{getUploadedDocument(0,frontText).description}}"
                                                          *ngIf="getUploadedDocument(0,frontText).isVirusClean()">attachment
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="File is Infected"
                                                          *ngIf="getUploadedDocument(0,frontText).isVirusInfected()">block
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="Virus Scan Pending"
                                                          *ngIf="getUploadedDocument(0,frontText).isVirusPending()">warning
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="Virus Scan In Progress"
                                                          *ngIf="getUploadedDocument(0,frontText).isVirusInProgress()">warning
                                                </mat-icon>
                                                <span class="mat-card-list-text">{{getUploadedDocument(0,frontText).documentName}} - {{getUploadedDocument(0,frontText).description}}</span>

                                            </div>
                                            <div class="mat-card-connect-client-list-right" *ngIf="hoveredIndex==0">
                                                <button class="mat-card-icon" mat-icon-button
                                                        aria-label="Delete the front of the driver's licnece"
                                                        (click)="deleteDocument(getUploadedDocument(0,frontText))">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                            <mat-divider></mat-divider>
                                        </mat-list-item>
                                    </mat-list>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!isUploadIdVisible(0, backText)">
                                <div class="padding-top-10">
                                    <mat-list role="list" *ngIf="getUploadedDocument(0,backText)">
                                        <mat-list-item role="listitem" (mouseenter)="hoveredIndex=0">
                                            <div class="mat-card-connect-client-list-left">
                                                <mat-icon class="mat-card-connect-icon"
                                                          title="{{getUploadedDocument(0,backText).description}}"
                                                          *ngIf="getUploadedDocument(0,backText).isVirusClean()">attachment
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="File is Infected"
                                                          *ngIf="getUploadedDocument(0,backText).isVirusInfected()">block
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="Virus Scan Pending"
                                                          *ngIf="getUploadedDocument(0,backText).isVirusPending()">warning
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="Virus Scan In Progress"
                                                          *ngIf="getUploadedDocument(0,backText).isVirusInProgress()">warning
                                                </mat-icon>
                                                <span class="mat-card-list-text">{{getUploadedDocument(0,backText).documentName}} - {{getUploadedDocument(0,backText).description}}</span>

                                            </div>
                                            <div class="mat-card-connect-client-list-right" *ngIf="hoveredIndex==0">
                                                <button class="mat-card-icon" mat-icon-button
                                                        aria-label="Delete the back of the driver's licnece"
                                                        (click)="deleteDocument(getUploadedDocument(0,backText))">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                            <mat-divider></mat-divider>
                                        </mat-list-item>
                                    </mat-list>
                                </div>
                            </ng-container>

                        </div>
                    </ng-container>
                    <ng-container formGroupName="1" *ngIf="isSelectedSectionIdVerification2()">
                        <div >
                            <span class="header-details">
                               <i class="fa fa-info-circle padding-right-5"></i>Please select a second approved piece of ID below and enter the identification information for this client.
                            </span>
                            <div class="padding-top-10" [dp-field-visibility]="'cirfClientInfo.identification2.identificationTypeCode;cirfClientInfo.identification2.identificationNumber;cirfClientInfo.identification2.placeOfIssue;cirfClientInfo.identification2.expiryDate;cirfClientInfo.identification2.country'">
                                <h5>Secondary Identification</h5>
                            </div>
                            <div >
                                <div class="row col-12 padding-left-0 padding-right-0">
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.identification2.identificationTypeCode'">
                                        <mat-form-field  [hideRequiredMarker]="allowMissingFields">
                                            <mat-label>Type of ID</mat-label>
                                            <input type="text"
                                                   formControlName='identificationTypeCode'
                                                   my-auto-focus
                                                   maxlength="100"
                                                   matInput
                                                   [matAutocomplete]="auto2">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                        <mat-autocomplete #auto2="matAutocomplete" >
                                            <mat-option *ngFor="let option of filteredSecondaryIdentificationOptions" [value]="option.value">
                                                {{option.name}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.identification2.identificationNumber'">
                                        <mat-form-field  [hideRequiredMarker]="allowMissingFields" >
                                            <mat-label>Number</mat-label>
                                            <input *ngIf="!isSecondaryIdentificationTypeCodeCreditCard()" matInput
                                                   formControlName="identificationNumber" maxlength="50">
                                            <input *ngIf="isSecondaryIdentificationTypeCodeCreditCard()" matInput
                                                   formControlName="identificationNumber" type="password" maxlength="16">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                    </div>

                                </div>

                                <div class="row col-12 padding-left-0 padding-right-0">
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.identification2.placeOfIssue'">
                                        <mat-form-field  [hideRequiredMarker]="allowMissingFields" >
                                            <mat-label>Place of Issue</mat-label>
                                            <input matInput formControlName="placeOfIssue" maxlength="50">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.identification2.expiryDate'">
                                        <mat-form-field  >
                                            <mat-label>Expiry Date</mat-label>
                                            <input  matInput formControlName="expiryDate"
                                                    placeholder="Expiry Date (DD/MM/YYYY)"
                                                    (blur)="validateExpiryDate('expiryDate', 'identifications', '1')"
                                            >
                                            <input style="display: none" matInput
                                                   [matDatepicker]="secondaryExpiryDatePicker"
                                                   (dateChange)="setExpiryDate('expiryDate', 'identifications', '1' ,$event)"
                                            >
                                            <mat-datepicker-toggle matSuffix [for]="secondaryExpiryDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #secondaryExpiryDatePicker></mat-datepicker>
                                            <mat-error *ngIf="checkError('expiryDate', 'identifications', '1')">Expiry Date is
                                                invalid</mat-error>
                                            <mat-hint class="warning-box" *ngIf="checkWarning('expiryDate', 'identifications', '1')">Expiry date is incomplete</mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'cirfClientInfo.identification2.country'">
                                        <mat-form-field  >
                                            <mat-label>Country</mat-label>
                                            <input matInput formControlName="country" maxlength="75">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-12 padding-left-0 padding-right-0">
                                    <dp-cirf-udf
                                            [formGroup]="secondaryIdentificationFormGroup"
                                            [cirfFormArrayName]="'identificationUdfs'"
                                            [cirfUdfFieldKey]="secondaryIdentificationUdfFieldKey"
                                            [cirfUdfs]="secondaryIdentificationUdfs"
                                    ></dp-cirf-udf>
                                </div>

                            </div>
                        </div>
                        <div *ngIf="isIdentificationSelected(1) && clientName">
                            <div class="padding-top-10">
                                <h3>{{getUploadText(1)}}</h3>
                            </div>
                            <ng-container *ngIf="isUploadIdVisible(1, frontText)">
                                <div class="padding-top-10">
                                    <dp-file-upload
                                            [sourceId]="clientId"
                                            [documentType]="'CLIENT'"
                                            [clientName]="clientName"
                                            uploadBtnLabel="{{getUploadButtonText(1,frontText)}}"
                                            [documentDescription]="getUploadedFileDescription(1, frontText)"
                                            (documentUploaded)="documentUploaded($event)"
                                    ></dp-file-upload>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="isUploadIdVisible(1, backText)">
                                <div class="padding-top-10">
                                    <dp-file-upload
                                            [sourceId]="clientId"
                                            [documentType]="'CLIENT'"
                                            [clientName]="clientName"
                                            uploadBtnLabel="{{getUploadButtonText(1,backText)}}"
                                            [documentDescription]="getUploadedFileDescription(1, backText)"
                                            (documentUploaded)="documentUploaded($event)"
                                    ></dp-file-upload>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!isUploadIdVisible(1, frontText)">
                                <div class="padding-top-10">
                                    <mat-list role="list" *ngIf="getUploadedDocument(1,frontText)">
                                        <mat-list-item role="listitem" (mouseenter)="hoveredIndex=0">
                                            <div class="mat-card-connect-client-list-left">
                                                <mat-icon class="mat-card-connect-icon"
                                                          title="{{getUploadedDocument(1,frontText).description}}"
                                                          *ngIf="getUploadedDocument(1,frontText).isVirusClean()">attachment
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="File is Infected"
                                                          *ngIf="getUploadedDocument(1,frontText).isVirusInfected()">block
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="Virus Scan Pending"
                                                          *ngIf="getUploadedDocument(1,frontText).isVirusPending()">warning
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="Virus Scan In Progress"
                                                          *ngIf="getUploadedDocument(1,frontText).isVirusInProgress()">warning
                                                </mat-icon>
                                                <span class="mat-card-list-text">{{getUploadedDocument(1,frontText).documentName}} - {{getUploadedDocument(1,frontText).description}}</span>

                                            </div>
                                            <div class="mat-card-connect-client-list-right" *ngIf="hoveredIndex==0">
                                                <button class="mat-card-icon" mat-icon-button
                                                        aria-label="Delete the front of the driver's licnece"
                                                        (click)="deleteDocument(getUploadedDocument(1,frontText))">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                            <mat-divider></mat-divider>
                                        </mat-list-item>
                                    </mat-list>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!isUploadIdVisible(1, backText)">
                                <div class="padding-top-10">
                                    <mat-list role="list" *ngIf="getUploadedDocument(1,backText)">
                                        <mat-list-item role="listitem" (mouseenter)="hoveredIndex=0">
                                            <div class="mat-card-connect-client-list-left">
                                                <mat-icon class="mat-card-connect-icon"
                                                          title="{{getUploadedDocument(1,backText).description}}"
                                                          *ngIf="getUploadedDocument(1,backText).isVirusClean()">attachment
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="File is Infected"
                                                          *ngIf="getUploadedDocument(1,backText).isVirusInfected()">block
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="Virus Scan Pending"
                                                          *ngIf="getUploadedDocument(1,backText).isVirusPending()">warning
                                                </mat-icon>
                                                <mat-icon class="mat-card-connect-icon" title="Virus Scan In Progress"
                                                          *ngIf="getUploadedDocument(1,backText).isVirusInProgress()">warning
                                                </mat-icon>
                                                <span class="mat-card-list-text">{{getUploadedDocument(1,backText).documentName}} - {{getUploadedDocument(1,backText).description}}</span>

                                            </div>
                                            <div class="mat-card-connect-client-list-right" *ngIf="hoveredIndex==0">
                                                <button class="mat-card-icon" mat-icon-button
                                                        aria-label="Delete the back of the driver's licnece"
                                                        (click)="deleteDocument(getUploadedDocument(1,backText))">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                            <mat-divider></mat-divider>
                                        </mat-list-item>
                                    </mat-list>
                                </div>
                            </ng-container>

                        </div>
                    </ng-container>

                </div>
                <div class="connect-common-page-header" *ngIf="isClientNotesVisible() && isSelectedSectionNotes()">
                    <h2 class="header-text semi-bold-font">
                        <div>Client(s) Notes</div>
                    </h2>
                    <span class="header-details">
                        <i class="fa fa-info-circle padding-right-5"></i>Please add any notes that may be relevant to the personal details of the client(s).
                    </span>
                    <div class="padding-top-10">
                        <mat-form-field class="width-100">
                            <mat-label>Client Notes</mat-label>
                            <textarea rows="3" matInput formControlName="clientNotes" my-auto-focus></textarea>
                            <mat-error>This field is required</mat-error>
                        </mat-form-field>
                    </div>

                </div>

        </form>
    </div>
</div>
